<template>
  <div>
    <v-container fill-height fluid grid-list-xl>
      <Loader v-if="loading" :loading="loading" />

      <v-layout v-else  justify-center wrap>
        <v-flex md12>
          <v-btn color="success" class="mr-2" @click="saveTournaments()" text
            >Сохранить</v-btn
          >

          <br />
          <br />

          <v-text-field
            type="number"
            :loading="findLoading"
            v-model="dealer_id_new"
            label="ID Дилера"
          ></v-text-field>
          <v-btn color="info" :loading="findLoading" @click="setDealer()" text
            >Добавить</v-btn
          >
          <br />
          <br />
          <v-data-table :headers="headers" :items="dealers" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>

            <template slot="items" slot-scope="{ item }">
              <td class="text-xs-left">
                <b>{{ item.id }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ item.title }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ item.activations_sale_count }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ item.activations_reward }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ item.activations_bonus }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ item.phone_number }}</b>
              </td>
              <td class="text-xs-right">
                <v-icon class="mr-3 text-info" @click="infoItem(item)"
                  >mdi-information-outline</v-icon
                >
                <v-icon class="text-danger" @click="removeItem(item)"
                  >mdi-close</v-icon
                >
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      v-model="dealerModal"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-btn class="close default v-btn--simple" @click="dealerModal = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <div class="body-2 mt-5">
            <tournament-product-dealer
              v-if="dealer_id && dealerModal"
              :TournamentID="Tournament_id"
              :dealerID="dealer_id"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TournamentProductDealer from "./TournamentProductDealer";
import Loader from "../../helper/Loader";

export default {
  data: () => ({
    dealers: [],
    dealer_id_new: null,
    dealer_id: null,
    dealerModal: false,
    loading: true,
    findLoading: false,
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "id",
      },
      {
        sortable: false,
        text: "Дилер",
        value: "id",
      },
      {
        sortable: true,
        text: "Количество активаций",
        value: "activations_sale_count",
      },
      {
        sortable: true,
        text: "Общая награда",
        value: "activations_reward",
      },
      {
        sortable: true,
        text: "Доп. награда",
        value: "activations_bonus",
      },
      {
        sortable: false,
        text: "Номер телефона",
        value: "id",
      },
      {
        sortable: false,
        text: "",
        value: "dealer.name",
      },
    ],
  }),
  components: { Loader, TournamentProductDealer },
  methods: {
    removeItem(item) {
      for (let i = 0; i < this.dealers.length; i++) {
        if (this.dealers[i].id === item.id) {
          this.dealers.splice(i, 1);
        }
      }
    },
    getItems() {
      axios
        .get("admin/tournaments/dealers/" + this.Tournament_id)
        .then((response) => {
          this.dealers = response.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    },
    saveTournaments() {
      this.loading = true;
      axios
        .post("admin/tournaments/set/dealers", {
          id: this.Tournament_id,
          items: this.dealers,
        })
        .then((response) => {
          this.getItems();
        })
        .finally(() => {
          //   setTimeout(() => {
          //     this.loading = false;
          //   }, 400);
        });
    },

    setDealer() {
      this.findLoading = true;
      axios
        .get("admin/dealers/search", {
          params: {
            search: this.dealer_id_new,
          },
        })
        .then((response) => {
          if (response.data && response.data.id) {
            let access = true;
            for (let i = 0; i < this.dealers.length; i++) {
              if (this.dealers[i].id === response.data.id) {
                access = false;
              }
            }
            if (access) {
              this.dealers.unshift(response.data);
              this.$toast.success({
                title: "Новый дилер",
                message: "Прикреплен",
              });
            }
          } else {
            this.$toast.error({
              title: "Новый дилер",
              message: "Не найден",
            });
          }
        })
        .finally(() => {
          this.findLoading = false;
          this.dealer_id_new = null;
        });
      // this.participant = {};
      // this.dealers.unshift({
      //     id: val.id,
      //     vendor_code:val.vendor_code,
      //     percent:0,
      //     iteration:0,
      //     title:'Несохраненный товар'
      // });
    },
    infoItem(item) {
      if (item && item.id) {
        this.dealer_id = item.id;
        this.dealerModal = true;
      }
    },
  },
  computed: {
    Tournament_id: {
      get() {
        return this.TournamentID;
      },
      set(val) {},
    },
  },
  props: ["TournamentID"],
  mounted() {
    this.getItems();
  },
};
</script>
